export const AUTH_BASE_URL = process.env.REACT_APP_API_URL;
export const AUTH_URL = AUTH_BASE_URL+'auth/sign_in';
export const CREATE_USER_URL = AUTH_BASE_URL+'auth';
export const UPDATE_PASSWORD_URL = AUTH_BASE_URL+'auth/password';
export const FORGOT_PASSWORD_URL = AUTH_BASE_URL+'auth/password';
export const RESET_PASSWORD_URL = AUTH_BASE_URL+'auth/password';
export const VALIDATE_TOKEN_URL = AUTH_BASE_URL+"auth/validate_token";

export const FIND_USER_URL = AUTH_BASE_URL+'auth/find_user_by_email';